import { render, staticRenderFns } from "./MaternityContribution.vue?vue&type=template&id=171d9e2c&scoped=true&"
import script from "./MaternityContribution.vue?vue&type=script&lang=js&"
export * from "./MaternityContribution.vue?vue&type=script&lang=js&"
import style0 from "./MaternityContribution.vue?vue&type=style&index=0&id=171d9e2c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171d9e2c",
  null
  
)

export default component.exports